import React from 'react'

export const ScoreDial = ({ score }) => (
  <div className='flex-wrapper'>
    <div className='single-score-dial'>
      <svg viewBox='0 0 36 36' className='single-score-dial__circular-chart'>
        <path
          className='single-score-dial__circle-bg'
          d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
        />
        <path
          className='single-score-dial__circle'
          d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
          strokeDasharray={`${score * 20}, 100`}
        />
        <div x='18' y='20.35' className='single-score-dial__score'>
          {score}/5
        </div>
      </svg>
    </div>
  </div>
)
